module.exports = __webpack_public_path__ + "static/media/amigosdanatureza-partitura.1b6c3743.png";